import { Injectable, inject } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { TransferStatus, TransfersApi } from '@adesso/dataspace-api-client';
import { ADESSO_API_CONFIG } from '../../../../core/api/adesso-api.config';
import { TransferOutcome, TransferProcess } from '../models/transfer-process.model';
import { TransferProcessApiPort } from '../ports/transfer-process-api.port';

@Injectable()
export class AdessoTransferProcessApiAdapter extends TransferProcessApiPort {
  private readonly api = new TransfersApi(inject(ADESSO_API_CONFIG));

  getTransferProcesses(): Observable<TransferProcess[]> {
    return from(this.api.getAllTransfers()).pipe(
      map((res) => (res.data ?? []).map(toDomain))
    );
  }
}

function toDomain(dto: TransferStatus): TransferProcess {
  return {
    id: dto.transferId ?? '',
    state: typeof dto.state === 'string' ? dto.state : String(dto.state ?? ''),
    outcome: dto.outcome as TransferOutcome | undefined,
    type: dto.transferType ?? '',
    contractId: dto.contractId ?? '',
    assetId: dto.assetId ?? '',
    createdAt: dto.createdAt ?? 0,
    stateTimestamp: dto.stateTimestamp ?? 0
  };
}
